import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  type: 'Channel Opps',
  currentYear: '',
  currentQuarter: '',
  selectedYear: '',
  selectedQuarter: '',
  compareSelectedYear: '',
  compareSelectedQuarter: '',
  channelOppsRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null
  },
  compareChannelOppsRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null
  },
}

const channelOppsSlice = createSlice({
  name: 'channelOpps',
  initialState,
  reducers: {
    setCurrentQuarter: (state, action) => {
      return { ...state, currentQuarter: action.payload }
    },
    setCurrentYear: (state, action) => {
      return { ...state, currentYear: action.payload }
    },
    setSelectedQuarter: (state, action) => {
      return { ...state, selectedQuarter: action.payload }
    },
    setSelectedYear: (state, action) => {
      return { ...state, selectedYear: action.payload }
    },
    setCompareSelectedYear: (state, action) => {
      return { ...state, compareSelectedYear: action.payload}
    },
    setCompareSelectedQuarter: (state, action) => {
      return { ...state, compareSelectedQuarter: action.payload }
    },
    setChannelOppsRange: (state, action) => {
      return { ...state, channelOppsRange: action.payload }
    },
    setCompareChannelOppsRange: (state, action) => {
      return { ...state, compareChannelOppsRange: action.payload }
    },
  }
})

export const channelOppsActions = channelOppsSlice.actions

export default channelOppsSlice.reducer
